import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/newsAdmin.css";
import loadingGif from "../../assets/images/loading.gif";
import { ShowNews } from "./ShowNews";
import { AddNews } from "./add-news";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class NewsAdmin_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsList: [],
      addNewsModal: false,
      showNewsModal: false,
      activeNews: {},
      seeArchive: false,
      isLoading: true,
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("tokenAdmin")),
      },
    };
  }

  componentDidMount = () => {
    this.getAnnouncements();
  };

  getAnnouncements = (returnArchive = false) => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/announcements`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({ isLoading: false });
        if (returnArchive) {
          this.setState({
            newsList: res.data.result.filter(
              ({ status, type }) => status === "archived" && type === "1"
            ),
          });
        } else {
          this.setState({
            newsList: res.data.result.filter(
              ({ status, type }) => status !== "archived" && type === "1"
            ),
          });
        }
        // res.data.result.map(({ id }) => this.putData({ id, status: "active" }));
        // res.data.result.map(({ id }) => this.putData({ id, status: "archived" }));
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putData = (data) => {
    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/announcements`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({ isLoading: false });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleRow = (newsIndex, val) => {
    const { newsList } = this.state;
    const arr = [...newsList];
    arr[newsIndex] = val;
    this.setState({ newsList: arr.filter((item) => item !== null) });
  };

  handleStatus = (i) => {
    const { handleRow, putData } = this;
    const { newsList } = this.state;
    const prevStatus = newsList[i].status;
    const oppositeStatus = prevStatus === "active" ? "deactive" : "active";

    this.props
      .dispatch(
        userActions.question(
          "وضعیت انتشار",
          "آیا از تغییر وضعیت انتشار مطمئن هستید؟"
        )
      )
      .then((r) => {
        if (r.value) {
          this.setState({ isLoading: true });
          handleRow(i, {
            ...newsList[i],
            status: oppositeStatus,
          });
          putData({
            id: newsList[i].id,
            status: oppositeStatus,
          });
        }
      });
  };

  handleArchive = (i) => {
    const { handleRow, putData } = this;
    const { newsList, seeArchive } = this.state;
    const title = seeArchive ? "لغو آرشیو" : "آرشیو";
    const subTitle = seeArchive
      ? "آیا از لغو آرشیو خبر مطمئن هستید؟"
      : "آیا از آرشیو خبر مطمئن هستید؟";

    this.props.dispatch(userActions.question(title, subTitle)).then((r) => {
      if (r.value) {
        this.setState({ isLoading: true });
        handleRow(i, null);
        putData({
          id: newsList[i].id,
          status: seeArchive ? "active" : "archived",
        });
      }
    });
  };

  getUnitString = (value, unit) => {
    return `${value} ${unit}`;
    // return `${value} ${unit}${value > 1 ? "s" : ""}`;
  };

  formatDuration = (seconds) => {
    // if (seconds === 0) return "اتمام زمان انجام کار";
    if (seconds < 61) return "کمتر از یک دقیقه";

    if (seconds < 86400) {
      //less than a day
      const units = [
        // { unit: "سال", duration: 60 * 60 * 24 * 365 },
        // { unit: "روز", duration: 60 * 60 * 24 },
        { unit: "ساعت", duration: 60 * 60 },
        { unit: "دقیقه", duration: 60 },
        // { unit: "ثانیه", duration: 1 },
      ];

      const result = units
        .map(({ unit, duration }) => {
          const value = Math.floor(seconds / duration);
          seconds -= value * duration;
          return value > 0 ? this.getUnitString(value, unit) : null;
        })
        .filter((unitString) => unitString !== null);

      return result.length === 1 ? result[0] : result.join(" و ");
    } else {
      //more than a day
      const units = [
        { unit: "سال", duration: 60 * 60 * 24 * 365 },
        { unit: "روز", duration: 60 * 60 * 24 },
        // { unit: "ساعت", duration: 60 * 60 },
        // { unit: "دقیقه", duration: 60 },
        // { unit: "ثانیه", duration: 1 },
      ];

      const result = units
        .map(({ unit, duration }) => {
          const value = Math.floor(seconds / duration);
          seconds -= value * duration;
          return value > 0 ? this.getUnitString(value, unit) : null;
        })
        .filter((unitString) => unitString !== null);

      return result.length === 1 ? result[0] : result.join(" و ");
    }
  };

  render() {
    const { handleArchive, handleStatus, formatDuration } = this;
    const { newsList, seeArchive, isLoading, addNewsModal, showNewsModal } =
      this.state;
    return (
      <div className="container-fluid px-5 pb-5 mt-3 newsAdmin">
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto">
            <List
              seeArchive={seeArchive}
              onAdd={() => {
                this.setState({ addNewsModal: true });
              }}
              onArchive={() => {
                this.setState({ seeArchive: !seeArchive, isLoading: true });
                this.getAnnouncements(!seeArchive);
              }}
            >
              {isLoading ? (
                <Loading />
              ) : seeArchive ? (
                newsList.length ? (
                  newsList.map((news, i) => (
                    <ListItem2
                      i={i}
                      key={i + 1}
                      news={news}
                      formatDuration={formatDuration}
                      onArchive={() => handleArchive(i)}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )
              ) : newsList.length ? (
                newsList.map((news, i) => (
                  <ListItem
                    i={i}
                    key={i + 1}
                    news={news}
                    onStatus={() => handleStatus(i)}
                    onArchive={() => handleArchive(i)}
                    onShowNews={() =>
                      this.setState({
                        activeNews: newsList.find(
                          (item) => item.id === news.id
                        ),
                        showNewsModal: true,
                      })
                    }
                    onEdit={(id) =>
                      this.setState({
                        addNewsModal: !this.state.addNewsModal,
                        activeNews: this.state.newsList.find(
                          (news) => news.id === id
                        ),
                      })
                    }
                  />
                ))
              ) : (
                <EmptyListItem />
              )}
            </List>
            <Modal
              isOpen={addNewsModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
            >
              <AddNews
                data={this.state.activeNews}
                handleModal={() => {
                  this.setState({ addNewsModal: !this.state.addNewsModal });
                }}
                afterPost={this.getAnnouncements}
              />
            </Modal>
            <Modal
              isOpen={showNewsModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
            >
              <ShowNews
                data={this.state.activeNews}
                onClose={() =>
                  this.setState({
                    activeNews: {},
                    showNewsModal: false,
                  })
                }
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="newsAdmin__list__item empty-list">
        <p className="newsAdmin__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onAdd, onArchive, seeArchive } = this.props;

    return (
      <div className='list-wrapper'>
        <ul className='newsAdmin__list'>
          <Banner seeArchive={seeArchive} />
          {this.props.children}
        </ul>
        <div className=' d-flex justify-content-center mt-4'>
          {seeArchive ? (
            <button
              className='btn btn-primary rounded-pill mx-2 add_event_btn py-3'
              onClick={onArchive}
            >
              مشاهده اخبار فعال{' '}
            </button>
          ) : (
            <>
              <button
                className='btn btn-primary rounded-pill mx-2 add_event_btn py-3'
                onClick={onAdd}
              >
                افزودن خبر
              </button>
              <button
                className='btn rounded-pill mx-2 empty_button mx-2 empty_button py-3'
                onClick={onArchive}
              >
                مشاهده آرشیو
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    const { seeArchive } = this.props;
    const grid = seeArchive
      ? "1fr 10fr 2fr 2fr 2fr 2fr"
      : "1fr 10fr 2fr 2fr 2fr 2fr";
    return (
      <li
        className="newsAdmin__list__banner"
        key="0"
        style={{ gridTemplateColumns: grid }}
      >
        <div className="newsAdmin__list__banner__child">ردیف</div>
        <div className="newsAdmin__list__banner__child">عنوان خبر</div>
        {seeArchive ? (
          <>
            <div className="newsAdmin__list__banner__child">
              مدت زمان انتشار
            </div>
            <div className="newsAdmin__list__banner__child">تاریخ آرشیو</div>
          </>
        ) : (
          <>
            <div className="newsAdmin__list__banner__child">پیش نمایش</div>
            <div className="newsAdmin__list__banner__child">وضعیت انتشار</div>
          </>
        )}
        {/* <div className="newsAdmin__list__banner__child">
          {seeArchive ? "تاریخ آرشیو" : "وضعیت انتشار"}
        </div> */}
        <div className="newsAdmin__list__banner__child">تاریخ انتشار</div>
        <div className="newsAdmin__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem2 extends Component {
  render() {
    if (this.props.news === undefined) return null;

    const { i, news, onArchive, formatDuration } = this.props;
    const {
      id,
      title,
      // subtitle,
      // body,
      // category,
      // author,
      // seen_count,
      status,
      created_at,
      updated_at,
    } = news;
    const grid = "1fr 10fr 2fr 2fr 2fr 2fr";

    const startInSecondes = Math.floor(new Date(created_at).getTime() / 1000);
    const finishInSecondes = Math.floor(new Date(updated_at).getTime() / 1000);
    const passed = finishInSecondes - startInSecondes;

    return (
      <li
        className={`newsAdmin__list__item`}
        style={{ gridTemplateColumns: grid }}
      >
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDuration(passed)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(updated_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(created_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className={`library-dark-icon`} onClick={onArchive} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    if (this.props.news === undefined) return null;

    const { i, news, onStatus, onArchive, onShowNews, onEdit } = this.props;
    const {
      id,
      title,
      // subtitle,
      // body,
      // category,
      // author,
      // seen_count,
      status,
      created_at,
    } = news;
    const grid = "1fr 10fr 2fr 2fr 2fr 2fr";

    return (
      <li
        className={`newsAdmin__list__item`}
        style={{ gridTemplateColumns: grid }}
      >
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className="eye-icon" onClick={onShowNews} />
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound
            className={`${
              status === "active"
                ? "success"
                : status === "deactive"
                ? "error"
                : "library"
            }-icon`}
            onClick={onStatus}
          />
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(created_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className="edit-icon" onClick={() => onEdit(id)} />
          <BtnRound className={`library-icon`} onClick={onArchive} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="newsAdmin__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Loading extends Component {
  render() {
    return (
      <li className="newsAdmin__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

const NewsAdmin = connect((state) => ({
  globalStorage: state.globalStorage,
}))(NewsAdmin_);

export { NewsAdmin };
